@if (pushs && pushs.length) {
  <sd-component-wrapper [content]="wrapperContent">
    <div sd-component-wrapper-component class="row justify-content-center">
      <div class="col">
        <sd-push-slider [pushs]="pushs" [size]="sizesEnum" [titleLevel]="1" [brand]="brand" />
      </div>
    </div>
  </sd-component-wrapper>
}
